import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useIntegrations } from "@/features/integrations/hooks/useIntegrations";
import { ModuleName } from "@/features/integrations/utils/module-name";
import { decodeSlug } from "@/features/integrations/utils/slug";
import { useAuth } from "@/lib/hooks/useAuth";
import { useBreadcrumbs } from "@/lib/hooks/useBreadcrumbs";

export function useJobSourceTenantDetailsBreadcrumbs() {
  const { t, i18n } = useTranslation();
  const { integrationName } = useParams<{
    integrationName?: string;
  }>();
  const { tenantId } = useAuth();
  const integrationsQuery = useIntegrations({ tenantId, clientId: null });

  const decodedIntegrationName = integrationName
    ? decodeSlug(integrationName)
    : null;

  const backendIntegrationName = decodedIntegrationName;

  const integration =
    integrationsQuery.data?.find(
      (i) =>
        i.name === backendIntegrationName
    ) ?? null;

  const integrationDisplayName =
    integration?.displayName && i18n.exists(integration.displayName)
      ? t(integration.displayName)
      : integration?.displayName;

  const moduleDisplayName = t(`integrations.modules.names.${ModuleName.JobSource}`);

  const breadcrumbs = useBreadcrumbs({
    items: [
      { label: t("common.integrations"), href: `/${ROUTES.integrations}` },
      {
        label: integrationDisplayName ?? t("common.integration"),
        href: integrationName
          ? `/${ROUTES.integrations}/${integrationName}`
          : undefined,
      },
      {
        label: moduleDisplayName,
      },
    ],
  });

  return { breadcrumbs, integration };
}
